var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRecordingStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.71875,
    y: 3.5,
    width: 9,
    height: 9,
    rx: 1.5,
    fill: "white",
    fillOpacity: 0.62
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecordingStop);
export default __webpack_public_path__ + "static/media/icon-recording-stop.d4c53291201f7dc2f84c4c9a2fe63589.svg";
export { ForwardRef as ReactComponent };